import type { Theme } from '@mui/material';
import { toggleButtonClasses, toggleButtonGroupClasses } from '@mui/material';
import type { /*Components, */ Palette, PaletteColor } from '@mui/material/styles';

import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

type Variant = {
  props: Record<string, unknown>;
  style: Record<string, unknown>;
};

export const CUSTOM_ATTRIBUTE_EQUAL_WIDTH = 'data-0';
export const CUSTOM_ATTRIBUTE_SHAPE = 'data-1';

export default function MUIToggleButtonGroup(theme: Theme) /* : Components['MuiToggleButtonGroup'] */ {
  return {
    defaultProps: {
      color: 'primary',
    },
    // styleOverrides: {},
    variants: [
      ...Object.entries(theme.palette)
        .filter(([key]) => !!(theme.palette[key as keyof Palette] as PaletteColor).contrastText && key !== 'neutral')
        .reduce<Variant[]>(
          (acc, [key, value]) =>
            acc.concat({
              props: {
                color: key,
              },
              style: {
                [`& .${toggleButtonClasses.root}`]: {
                  [`&.${toggleButtonClasses.selected}`]: {
                    color: value.contrastText,
                    backgroundColor: value.main,

                    '&:hover': {
                      backgroundColor: value.dark,
                    },
                  },
                },
              },
            }),
          [],
        ),
      {
        props: {
          color: 'neutral',
        },
        style: {
          [`& .${toggleButtonClasses.root}`]: {
            [`&.${toggleButtonClasses.selected}`]: {
              color: theme.palette.shades[900],
              backgroundColor: theme.palette.shades[300],

              '&:hover': {
                backgroundColor: theme.palette.shades[400],
              },
            },
          },
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_EQUAL_WIDTH]: '' },
        style: {
          display: 'inline-grid',
          gridTemplateColumns: 'repeat(var(--internal-children-count), 1fr)',

          [`& .${toggleButtonClasses.root}`]: {
            minWidth: 'max-content',
          },
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_SQUARE },
        style: {
          borderRadius: 0,
          [`& .${toggleButtonGroupClasses.firstButton}`]: {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
          [`& .${toggleButtonGroupClasses.lastButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_CIRCULAR },
        style: {
          borderRadius: theme.shape.borderRadiusCircular,
          [`& .${toggleButtonGroupClasses.firstButton}`]: {
            borderTopLeftRadius: theme.shape.borderRadiusCircular,
            borderBottomLeftRadius: theme.shape.borderRadiusCircular,
          },
          [`& .${toggleButtonGroupClasses.lastButton}`]: {
            borderTopRightRadius: theme.shape.borderRadiusCircular,
            borderBottomRightRadius: theme.shape.borderRadiusCircular,
          },
        },
      },
    ],
  };
}
